@use '@design/design-tokens/typography/typography' as *;

.insightsContainer {
  display: flex;
  gap: 4px;
  align-items: center;
}

.count {
  @include typography-v2-body-xs;
  color: var(--text-soft);
  width: 15px;
  height: 16px;
}

.countDisabled {
  @include typography-v2-body-xs;
  color: var(--text-disabled);
  width: 15px;
  height: 16px;
}
